import { Pv } from '@weblite/ts-action/pv'
import { useSelector } from 'react-redux'
import { RootState } from '$setup/redux'
import { useAsyncFunction } from '$func/async-function.react-hook'
import { createUseEntity } from '$func/create-use-entity.react-hook'
import { pvsStorage } from './storage'

const getPvsView = (state: RootState): Record<string, Pv> => state.main.pvs

const getPvView = (roomId: string) => (state: RootState): Pv =>
  state.main.pvs[roomId]

export const usePv = createUseEntity<Pv>(getPvView, pvsStorage.get)

export function usePvs() {
  return useSelector(getPvsView)
}

export function usePvSync(roomId: string) {
  return useSelector(getPvView(roomId))
}

export function usePvByUserId(userId: string) {
  const { value: storedPv, loading, error } = useAsyncFunction(
    () => pvsStorage.findByUser(userId),
    [userId],
  )

  const { entity: pv } = usePv(storedPv?.roomId)

  return { pv, loading, error }
}
